export default "__VITE_ASSET__Dkoehe$t__"